export default __webpack_public_path__ + "cb6787903cdcf3ba5b626abfa09cca9f.png";